import {
  ContentNugget,
  ContentCompetency,
  Scholarship,
  BackrsUser,
  mapCareerPathResponseToCareerPath,
  CareerPathResponse,
  Internship,
  ExternalProfile,
  College,
} from '@backrs_ui/common-ui';

export const competencyTransform = (contentCompetency: ContentCompetency): ContentNugget => {
  const competencyAsNugget: ContentNugget = {
    id: contentCompetency.id,
    title: contentCompetency.title,
    description: contentCompetency.description,
    slug: contentCompetency.slug,
    star_rating: 0, // doesn't matter for competencies
    value_rating: 0, // doesn't matter for competencies
    variant: 'competency',
    is_browsable: false, // doesn't matter for competencies
  };

  return competencyAsNugget;
};

export const scholarshipTransform = (scholarship: Scholarship): ContentNugget => {
  const scholarshipAsNugget: ContentNugget = {
    id: scholarship.id,
    title: scholarship.name,
    description: scholarship.description,
    slug: scholarship.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'scholarships',
    is_browsable: false,
    scholarship_info: scholarship,
  };

  return scholarshipAsNugget;
};

export const externalProfileTransform = (externalProfile: ExternalProfile): ContentNugget => {
  const externalProfileAsNugget: ContentNugget = {
    id: externalProfile.id,
    title: `Connect with and Review ${externalProfile.first_name} ${externalProfile.last_name}'s Profile`,
    description: externalProfile.description,
    slug: externalProfile.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'profile-external',
    content_nugget_theme: 'Profile',
    is_browsable: false,
    external_profile_info: externalProfile,
  };

  return externalProfileAsNugget;
};

export const profileTransform = (profile: BackrsUser): ContentNugget => {
  const profileAsNugget: ContentNugget = {
    id: profile.id,
    title: `Connect with and Review ${`${profile.first_name ? profile.first_name : ''} ${profile.last_name ? `${profile.last_name[0]}.` : ''}`}'s Profile`,
    description: profile.bio || '',
    slug: profile.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'profile-internal',
    profile_info: profile,
    is_browsable: false,
  };

  return profileAsNugget;
};

export const careerPathTransform = (career_path: CareerPathResponse): ContentNugget => {
  const careerPathAsNugget: ContentNugget = {
    id: career_path.id,
    title: career_path.name,
    description: career_path.description,
    slug: career_path.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'career-path',
    content_nugget_theme: 'Career Path',
    is_browsable: false,
    career_path_info: mapCareerPathResponseToCareerPath(career_path),
  };

  return careerPathAsNugget;
};

export const collegeTransform = (college: College): ContentNugget => {
  const collegeAsNugget: ContentNugget = {
    id: college.id,
    title: college.school_name,
    description: college.description || '',
    slug: college.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'institution',
    external_url: college.url,
    preview_media:
      college.banner_media_id && college.banner_media_url
        ? {
            id: college.banner_media_id,
            media_url: college.banner_media_url,
          }
        : undefined,
    content_nugget_theme: 'College',
    type: 'institution-university',
    is_browsable: false,
    college_info: college,
  };

  return collegeAsNugget;
};

export const internshipTransform = (internship: Internship): ContentNugget => {
  const internshipAsNugget: ContentNugget = {
    id: internship.id,
    title: internship.role_title,
    description: internship.ai_description,
    slug: internship.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'internship',
    content_nugget_theme: 'Opportunity',
    is_browsable: false,
    internship_info: internship,
  };

  return internshipAsNugget;
};
